export default __webpack_public_path__ + "static/media/IconEmail.b7de6c7e.svg";